import {
  InsumoProveedorStockEstado,
  InsumoProveedorStockEstadoLabels,
} from 'src/utils/enums/InsumoProveedorStockEstado';
import { InsumoProveedorStockFormState } from './types';

import {} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';
import { colorMapping } from 'src/utils/enums/InsumoProveedorStockEstado';

const initialState: InsumoProveedorStockFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'insumoProveedorStockForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },
    setFormStatusBorrador(state) {
      state.status = {
        id: InsumoProveedorStockEstado.Borrador,
        text: InsumoProveedorStockEstadoLabels[
          InsumoProveedorStockEstado.Borrador
        ].toUpperCase(),
        color: colorMapping[InsumoProveedorStockEstado.Borrador],
      };
      state.data = {
        lote: { readOnly: false },
        cantidad: { readOnly: false },
        estado: { readOnly: false },
        vencimiento: { readOnly: false },
        fechaIngresado: { readOnly: false },
        precioUnitario: { readOnly: false },
        precioPorBulto: { readOnly: false },
        insumoProveedorCodigoProveedor: { readOnly: false },
        insumoProveedorProveedorId: { readOnly: false },
        insumoProveedorInsumoCodigo: { readOnly: false },
        comprasId: { readOnly: false },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },

    setFormStatusVencido(state) {
      state.status = {
        id: InsumoProveedorStockEstado.Vencido,
        text: InsumoProveedorStockEstadoLabels[
          InsumoProveedorStockEstado.Vencido
        ].toUpperCase(),
        color: colorMapping[InsumoProveedorStockEstado.Vencido],
      };
      state.data = {
        lote: { readOnly: true },
        cantidad: { readOnly: false },
        estado: { readOnly: false },
        vencimiento: { readOnly: false },
        fechaIngresado: { readOnly: false },
        precioUnitario: { readOnly: false },
        precioPorBulto: { readOnly: false },
        insumoProveedorCodigoProveedor: { readOnly: true },
        insumoProveedorProveedorId: { readOnly: true },
        insumoProveedorInsumoCodigo: { readOnly: true },
        comprasId: { readOnly: true },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
    setFormStatusAgotado(state) {
      state.status = {
        id: InsumoProveedorStockEstado.Agotado,
        text: InsumoProveedorStockEstadoLabels[
          InsumoProveedorStockEstado.Agotado
        ].toUpperCase(),
        color: colorMapping[InsumoProveedorStockEstado.Agotado],
      };
      state.data = {
        lote: { readOnly: true },
        cantidad: { readOnly: false },
        estado: { readOnly: false },
        vencimiento: { readOnly: false },
        fechaIngresado: { readOnly: false },
        precioUnitario: { readOnly: false },
        precioPorBulto: { readOnly: false },
        insumoProveedorCodigoProveedor: { readOnly: true },
        insumoProveedorProveedorId: { readOnly: true },
        insumoProveedorInsumoCodigo: { readOnly: true },
        comprasId: { readOnly: true },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
    setFormStatusEnStock(state) {
      state.status = {
        id: InsumoProveedorStockEstado.EnStock,
        text: InsumoProveedorStockEstadoLabels[
          InsumoProveedorStockEstado.EnStock
        ].toUpperCase(),
        color: colorMapping[InsumoProveedorStockEstado.EnStock],
      };
      state.data = {
        lote: { readOnly: true },
        cantidad: { readOnly: false },
        estado: { readOnly: false },
        vencimiento: { readOnly: false },
        fechaIngresado: { readOnly: false },
        precioUnitario: { readOnly: false },
        precioPorBulto: { readOnly: false },
        insumoProveedorCodigoProveedor: { readOnly: true },
        insumoProveedorProveedorId: { readOnly: true },
        insumoProveedorInsumoCodigo: { readOnly: true },
        comprasId: { readOnly: true },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
  },
  extraReducers: (builder) => {},
});
// Selectors

export const selectFormStatus = (state: RootState) =>
  state.insumoProveedorStock.form.status;

export const selectGuardar = (state: RootState) =>
  state.insumoProveedorStock.form.actions?.guardar;

// Export actions
export const {
  resetForm,
  setFormStatusBorrador,
  setFormStatusVencido,
  setFormStatusAgotado,
  setFormStatusEnStock,
} = formSlice.actions;

export default formSlice.reducer;
